export default "__VITE_ASSET__1a16bf66__"